// getTimeRangeList.js
'use strict';

import { EMPTY_ARRAY } from '../resource/defaults.js';

/**
 * Turn a media element `TimeRanges` (played / buffered / seekable) into a plain
 * list so it can be rendered. `TimeRanges` is index based and cannot be mapped.
 * @param {object} param
 * @param {TimeRanges} [param.timeRanges] - ranges of a media element.
 * @returns {Array<{start: number, end: number}>} the ranges in order, or an
 * empty array when there are none.
 * @example
 * // timeRanges holds [[0, 15], [30, 40]]
 * getTimeRangeList({ timeRanges });
 * // => [{ start: 0, end: 15 }, { start: 30, end: 40 }]
 */
const getTimeRangeList = ({ timeRanges } = {}) => {
  if (!timeRanges?.length) return EMPTY_ARRAY;
  const rangeList = [];
  for (let index = 0; index < timeRanges.length; index += 1) {
    rangeList.push({
      start: timeRanges.start(index),
      end: timeRanges.end(index),
    });
  }
  return rangeList;
};

export default getTimeRangeList;
